
import { defineComponent } from "vue";
import AcademicYearContent from "./Components/AcademicYearContent.vue";

export default defineComponent({
  name: "AcademicYearPage",
  components: {
    AcademicYearContent,
  },
});
